import { render, staticRenderFns } from "./ResignationManagement.vue?vue&type=template&id=20e5c608&scoped=true"
import script from "./ResignationManagement.vue?vue&type=script&lang=js"
export * from "./ResignationManagement.vue?vue&type=script&lang=js"
import style0 from "./ResignationManagement.vue?vue&type=style&index=0&id=20e5c608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5c608",
  null
  
)

export default component.exports